import React from 'react'

import Navigation from 'src/ui/organisms/Navigation'
import Header from 'src/ui/organisms/Header'

const LoggedIn = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-row">
      <div className="flex-shrink-0 md:h-screen md:w-[200px]">
        <Navigation />
      </div>

      <div className="w-full px-8 pb-8 md:w-[calc(100%-200px)]">
        <Header />
        {children}
      </div>
    </div>
  )
}

export default LoggedIn
